import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AssignmentItem from '../../../Domain/AssignmentItem';
import AssignmentService from '../../../Services/AssignmentService';
import CurrencyNoteTextsEnum from '../../../Enums/CurrencyNoteTextsEnum';

class EditAssignmentWindowDescription extends React.Component {
  static titleForCreate = 'Add New Assignment';
  static titleForEdit = 'Edit Assignment';
  static itemType = AssignmentItem;
  static serviceFunction = (edited) => AssignmentService.EditAssignment(edited, null, false, null);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'asSassieAsgnId',
          label: 'Apollo ID',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'lgsDesc',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'asAdHocGroup',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'asUninvoiceable',
          label: 'Uninvoiceable?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.ciStatusCode !== null,
        },
        {
          fieldName: 'isApprovedEnabled',
          label: 'Enable EditFee Approved field?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.isApprovedHidden === true,
        },
        {
          fieldName: 'isApproved',
          label: 'EditFee Approved',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.isApprovedEnabled !== true,
        },
      ],
    },
    {
      label: 'Fieldwork',
      hide: (item) => item.ciStatusCode !== 1,
      fields: [
        {
          fieldName: 'evaluatorOfficeName',
          label: 'Fieldwork Office',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'inFieldworkFee',
          label: 'Fieldwork Fee',
          className: 'col-12',
          type: (item) => InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
      ],
    },
    {
      label: 'Client Billing',
      hide: (item) => item.ciStatusCode !== 1,
      fields: [
        {
          fieldName: 'inId',
          label: 'BARE Invoice #',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'invoiceStatus',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'inRcycode',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'inFee',
          label: 'Client Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'inFeeAddit',
          label: 'Additional Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'inReimbursement',
          label: 'Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'inMisc',
          label: 'Misc',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'inTravel',
          label: 'Travel',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'inGaming',
          label: 'Gaming',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
      ],
    },
    {
      label: 'Evaluator Payment',
      hide: (item) => item.ciStatusCode !== 1 && item.ieStatusCode !== 1,
      fields: [
        {
          fieldName: 'evaluatorCurrencyName',
          label: 'Currency',
          tooltipText: CurrencyNoteTextsEnum.EvaluatorPaymentEdit,
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'evaluatorPaymentStatus',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ieFee',
          label: 'Evaluator Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'ieFeeAdjustment',
          label: 'Additional Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'ieReimbursement',
          label: 'Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'ieMisc',
          label: 'Misc',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'ieTravel',
          label: 'Travel',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'ieGaming',
          label: 'Gaming',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
      ],
    },
  ];
}

export default EditAssignmentWindowDescription;
